import TopBar from './TopBar';
import Header from './Header';
import Section from './Section';
import StatModel from './StatModel';
import SingletonLoading from '../utils/SingletonLoading';
import { ALERT } from '../model/msg/stat';
import { getStatSimulatorTpl } from './../model/tpl/stat';
import { getClassDefaultStat, saveNewUserStat, deleteUserStat, saveUserStat, calculateStatByLevelUp, calculateStat } from './../utils/service';
import {
  isDefined,
  isString,
  isFunction,
  getDefined,
  not,
  parseInt10,
  parseStrIntToInt,
  allOf,
  anyOf,
  notSingleEle,
  truthy,
  falsy,
  getChangedStats,
  isLevelCanConsumeElixirStat,
  getPlusElixirPointByLevel,
  getStatMaxByLevel
} from '../../../utils/util';
import { handleApiError } from '../../../utils/service';
import { API_DOMAIN_DEFAULT } from '../../../model/model';

class StatSimulator {
  constructor(options) {
    const _ = this;

    if (not(isDefined)(options)) throw new Error('StatSimulator constructor require options object');

    _.option = $.extend({
      staticDomain: '',
      apiDomain: API_DOMAIN_DEFAULT,
      classId: '0',
      page: 'default', // default, modify, view
      wrap: null,
      data: null,
      classDefaultStatData: null,
      isLogin: false,
      savedUserStatNum: 0,
      useHighlightForDiff: true, // use only in setting qna board
      global: window
    }, options);

    _.model = StatModel.getInstance();

    _.loading = SingletonLoading.getInstance();

    _.wrap = null;

    _.topBar = null;

    _.header = null;

    _.section = null;

    _.data = _.option.data;

    _.statData = null;

    _.statDataFirstAtLevel = null;

    _.defaultStatsForDiff = null; // class lv50 default stat for display diff

    _.consumedPoint = 0;

    _.lastConsumedStatName = '';

    _.isUsedElixirAtCurrentLevel = false;

    _.isCompleteSetBaseStat = false;

    _.global = _.option.global;
  }

  init(obj = null) {
    const _ = this;

    _.wrap = $(_.option.wrap);
    if (notSingleEle(_.wrap)) throw new Error('wrap must be single element.');

    console.log('StatSimulator init _.data :', _.option.data);

    switch (_.option.page) {
      case 'default' :
        console.log('StatSimulator.init - default page');

        _.statData = StatModel.getDefaultStatData(_.data, { // _.data from getClassDefaultStat function
          'page': _.option.page,
          'type': _.model.DEVICE_TYPE,
          'classType': _.option.classId,
          'level': _.model.LEVEL_INIT,
          'currentLevel': _.model.LEVEL_INIT,
          'targetLevel': _.model.LEVEL_MAX
        });

        _.statDataFirstAtLevel = $.extend({}, _.statData);

        _.defaultStatsForDiff = $.extend({}, _.statData);

        _.isCompleteSetBaseStat = false;

        _.setInstance({page: 'default'});
        break;

      case 'view' :
        console.log('StatSimulator.init - view page');

        _.statData = _.data; // _.data from getSavedStatData function

        _.statDataFirstAtLevel = $.extend({}, _.statData);

        _.defaultStatsForDiff = StatModel.getDefaultStatData(_.option.classDefaultStatData, {
          'page': _.option.page,
          'type': _.model.DEVICE_TYPE,
          'classType': _.option.classId,
          'level': _.model.LEVEL_INIT,
          'currentLevel': _.model.LEVEL_INIT,
          'targetLevel': _.model.LEVEL_MAX
        });

        _.isCompleteSetBaseStat = true;

        _.setInstance({page: 'view'});
        break;

      case 'modify' :
        console.log('StatSimulator.init - modify page');

        _.statData = $.extend(_.data, {'page': _.option.page}); // _.data from getSavedStatData function of 'view' mode.

        _.statDataFirstAtLevel = $.extend({}, _.statData);

        _.defaultStatsForDiff = StatModel.getDefaultStatData(_.option.classDefaultStatData, {
          'page': _.option.page,
          'type': _.model.DEVICE_TYPE,
          'classType': _.option.classId,
          'level': _.model.LEVEL_INIT,
          'currentLevel': _.model.LEVEL_INIT,
          'targetLevel': _.model.LEVEL_MAX
        });

        _.isCompleteSetBaseStat = true;

        _.setInstance({page: 'modify'});
        break;
    }

    return _;
  }

  setInstance(obj = {page: ''}) {
    const _ = this;

    // empty previous simulator
    _.destroyContents();

    _.wrap.empty();

    // create new simulator // 2022.01 템플릿
    let contentsTplFunc = doT.template(getStatSimulatorTpl()),
      contentsTpl = '',
      changedStats = null;

    switch (obj.page) {
      case 'default' :
        console.log('default');

        console.log('=> StatSimulator.js setInstance() _.statData : ', _.statData );

        contentsTpl = contentsTplFunc($.extend(_.statData, {
          page: _.option.page,
          level: _.option.level,
          targetLevel : _.option.targetLevel,
          classImageUrl: `${_.option.staticDomain}/resource/lineage/profile/char${_.option.classId}_m.png`
        }));


        _.wrap.append(contentsTpl);

        _.topBar = new TopBar({
          page: _.option.page,
          wrap: $('header', _.wrap)
        }).init();

        _.header = new Header({
          wrap: $('section.char', _.wrap),
          data: _.statData
        }).init();

        _.section = new Section({
          wrap: $('section.variation', _.wrap)
        }).init();

        _.setTopBarEvents(true);
        _.setHeaderEvents(true);
        _.setSectionEvents(true);

        _.changeSectionBtnsStatus();
        break;

      case 'view' :
        console.log('view');

        contentsTpl = contentsTplFunc($.extend(_.statData, {page: _.option.page}));
        _.wrap.append(contentsTpl)

        _.topBar = new TopBar({
          page: _.option.page,
          wrap: $('header', _.wrap)
        }).init();

        _.section = new Section({
          wrap: $('section.variation', _.wrap),
          model: _.model
        }).init();

        _.setTopBarEvents(true);

        if (truthy(_.option.useHighlightForDiff)) {
          changedStats = getChangedStats(_.defaultStatsForDiff, _.statData);
          _.section.setHighlightChangedStats(changedStats);

        } else {
          // 'no highlight for diff'
        }
        break;

      case 'modify' :
        console.log('modify');

        contentsTpl = contentsTplFunc($.extend(_.statData, {page: _.option.page}));
        _.wrap.append(contentsTpl);

        _.topBar = new TopBar({
          page: _.option.page,
          wrap: $('header', _.wrap)
        }).init();

        _.header = new Header({
          wrap: $('section.char', _.wrap),
          data: _.statData,
          model: _.model
        }).init();

        _.section = new Section({
          wrap: $('section.variation', _.wrap),
          model: _.model
        }).init();

        _.setTopBarEvents(true);
        _.setHeaderEvents(true);
        _.setSectionEvents(true);

        _.changeSectionBtnsStatus();

        changedStats = getChangedStats(_.defaultStatsForDiff, _.statData);
        _.section.setHighlightChangedStats(changedStats);
        break;

      case 'reset:modify' :
        console.log('reset:modify');

        contentsTpl = contentsTplFunc($.extend(_.statData, {
          page: _.option.page,
          classImageUrl: `${_.option.staticDomain}/resource/lineage/profile/char${_.option.classId}_m.png`
        }));
        _.wrap.append(contentsTpl);

        _.topBar = new TopBar({
          page: _.option.page,
          wrap: $('header', _.wrap)
        }).init();

        _.header = new Header({
          wrap: $('section.char', _.wrap),
          data: _.statData,
          model: _.model
        }).init();

        _.section = new Section({
          wrap: $('section.variation', _.wrap),
          model: _.model
        }).init();

        _.setTopBarEvents(true);
        _.setHeaderEvents(true);
        _.setSectionEvents(true);

        _.changeSectionBtnsStatus();
        break;
    }

    _.setLevelUpKeyEvents(_.statData.type);
  }

  switchMode(prevPage, nextPage) {
    const _ = this;

    if (allOf(prevPage === 'view', nextPage === 'modify')) {
      _.option.page = 'modify';

      _.init();
    }
  }

  setTopBarEvents(flag) {
    const _ = this,
      $topBar = $(_.topBar);

    if ($topBar.length <= 0) return;

    if (truthy(flag)) {
      $topBar.on(TopBar.EVT_CLOSE, function (evt) {
        $(_).trigger({type: StatSimulator.EVT_CLOSE});
      });

      $topBar.on(TopBar.EVT_SAVE, function (evt) {
        if (truthy(_.loading.isLoading)) return;

        if (falsy(_.option.isLogin)) {
          _.global.alert(ALERT.CAN_SAVE_STAT_AFTER_LOGIN); // '스탯 세팅 저장은 로그인 후 이용 가능합니다.'
          return;
        }

        if (allOf(_.option.page === 'default', _.option.savedUserStatNum >= _.model.USER_STAT_NUM_LIMIT)) {
          _.global.alert(ALERT.SAVE_STAT_LIMIT); // '스탯 세팅 저장은 계정당 최대 6개까지 가능합니다. 새 세팅 결과 저장을 원한다면 기존 저장 내용 삭제 후 이용해주세요. 스탯 세팅을 계속 진행하시겠습니까?'
          return;
        }

        if (falsy(_.isEmptyRemainStat())) return;

        let stat = null, sendData = null;
        switch (_.option.page) {
          case 'default':
            stat = _.statData;

            sendData = {
              'classId': parseInt10(stat.classType),
              'targetLevel': stat.targetLevel,
              'level': stat.level,
              'statMetaInfo': {
                'hp': stat.HP,
                'mp': stat.MP,
                'mainStat': {
                  'STR': stat.STR,
                  'CON': stat.CON,
                  'DEX': stat.DEX,
                  'INT': stat.INT,
                  'WIS': stat.WIS,
                  'CHA': stat.CHA
                }
              },
              'statPointInfo': {
                'remainStatPoint': stat.remainStat,
                'totalStatPoint': stat.remainTotalStat,
                'remainElixirPoint': stat.elixirStat,
                'totalElixirPoint': stat.elixirTotalStat,
                'usedElixir': _.header.isCheckedElixirStatCheckBox()
              }
            };

            console.log( '=> StatSimulator.js stat(sendData) : ', stat );

            // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-POST/api/simulator/stat/user
            saveNewUserStat({
              apiDomain: _.option.apiDomain,
              sendData: sendData,
              beforeSend: () => _.loading.start()

            }).then((data, textStatus, jqXHR) => {
              console.log('saveNewUserStat - data :', data);

              _.loading.end();

              if (data.result === 'success') {
                $(_).trigger({type: StatSimulator.EVT_SAVE_STAT_COMPLETE});

              } else {
                if (falsy(handleApiError(data))) _.global.alert(ALERT.FAIL_SAVE_STAT); // '현재 스탯 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
              }

            }).catch((err) => {
              _.loading.end();

              if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_SAVE_STAT); // '현재 스탯 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
            });
            break;

          case 'modify':
            stat = _.statData;

            sendData = {
              'classId': parseInt10(stat.classType),
              'targetLevel': stat.targetLevel,
              'level': stat.level,
              'statMetaInfo': {
                'hp': stat.HP,
                'mp': stat.MP,
                'mainStat': {
                  'STR': stat.STR,
                  'CON': stat.CON,
                  'DEX': stat.DEX,
                  'INT': stat.INT,
                  'WIS': stat.WIS,
                  'CHA': stat.CHA
                }
              },
              'statPointInfo': {
                'remainStatPoint': stat.remainStat,
                'totalStatPoint': stat.remainTotalStat,
                'remainElixirPoint': stat.elixirStat,
                'totalElixirPoint': stat.elixirTotalStat,
                'usedElixir': _.header.isCheckedElixirStatCheckBox()
              }
            };

            // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-PUT/api/simulator/stat/user/:idx
            saveUserStat({
              apiDomain: _.option.apiDomain,
              idx: _.data.idx,
              sendData: sendData,
              beforeSend: () => _.loading.start()

            }).then((data, textStatus, jqXHR) => {
              console.log('saveUserStat - data :', data);

              _.loading.end();

              if (data.result === 'success') {
                $(_).trigger({type: StatSimulator.EVT_SAVE_STAT_COMPLETE});

              } else {
                if (falsy(handleApiError(data))) _.global.alert(ALERT.FAIL_SAVE_STAT); // '현재 스탯 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
              }

            }).catch((err) => {
              _.loading.end();

              if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_SAVE_STAT); // '현재 스탯 저장을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
            });

            break;
        }
      });

      $topBar.on(TopBar.EVT_TRY_RESET, function (evt) {
        console.log('TopBar.EVT_TRY_RESET');
        // none
      });

      $topBar.on(TopBar.EVT_RESET, function (evt) {
        console.log('TopBar.EVT_RESET');

        _.resetDefaultStat();
      });

      $topBar.on(TopBar.EVT_MODIFY, function (evt) {
        console.log('TopBar.EVT_MODIFY');

        if (falsy(_.option.isLogin)) {
          _.global.alert(ALERT.CAN_MODIFY_STAT_AFTER_LOGIN); // '스탯 세팅 수정은 로그인 후 이용 가능합니다.'
          return;
        }

        _.switchMode(_.option.page, 'modify');
      });

      $topBar.on(TopBar.EVT_DELETE, function (evt) {
        if (allOf(isString(_.statData.idx), _.statData.idx !== '')) {
          const msg = ALERT.TRY_DELETE_STAT({level: _.statData.level});

          const isConfirmDeleteStat = _.global.confirm(msg); // ${0}Lv 스탯 세팅을 삭제하시겠습니까?
          if (isConfirmDeleteStat) _.callDeleteApi(_.statData.idx);
        }
      });

    } else {
      $topBar
        .off(TopBar.EVT_CLOSE)
        .off(TopBar.EVT_SAVE)
        .off(TopBar.EVT_TRY_RESET)
        .off(TopBar.EVT_RESET)
        .off(TopBar.EVT_MODIFY)
        .off(TopBar.EVT_DELETE);
    }
  }

  resetDefaultStat() {
    const _ = this;

    switch (_.option.page) {
      case 'default':
        _.statData = $.extend({}, _.defaultStatsForDiff);
        _.statDataFirstAtLevel = $.extend({}, _.statData);

        _.isCompleteSetBaseStat = false;

        _.setInstance({page: 'default'});
        break;

      case 'modify':
        console.log('modify');

        _.data = $.extend(_.statData, _.defaultStatsForDiff);
        _.statData = $.extend({}, _.data);
        _.statDataFirstAtLevel = $.extend({}, _.statData);

        _.defaultStatsForDiff = $.extend({}, _.statData);

        _.isCompleteSetBaseStat = false;

        _.setInstance({page: 'reset:modify'});
        break;
    }
  }

  callDeleteApi(idx) {
    const _ = this;

    if (truthy(_.loading.isLoading)) return;

    if (falsy(_.option.isLogin)) {
      _.global.alert(ALERT.CAN_DELETE_STAT_AFTER_LOGIN); // '스탯 세팅 삭제는 로그인 후 이용 가능합니다.'
      return;
    }

    // http://wiki.korea.ncsoft.corp/pages/viewpage.action?pageId=99124757#WebDev-리니지RWDAPI-Simulator-DELETE/api/simulator/stat/user/:idx
    deleteUserStat({
      apiDomain: _.option.apiDomain,
      idx: idx,
      beforeSend: () => _.loading.start()

    }).then((data, textStatus, jqXHR) => {
      console.log('deleteUserStat - data :', data);

      _.loading.end();

      if (data.result === 'success') {
        $(_).trigger({type: StatSimulator.EVT_DELETE_STAT_COMPLETE});

      } else {
        if (falsy(handleApiError(data))) _.global.alert(ALERT.FAIL_DELETE_STAT); // '현재 스탯 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
      }

    }).catch((err) => {
      _.loading.end();

      if (falsy(handleApiError(jqXHR))) _.global.alert(ALERT.FAIL_DELETE_STAT); // '현재 스탯 삭제를 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });
  }

  setHeaderEvents(flag) {
    const _ = this,
      $header = $(_.header);

    if ($header.length <= 0) return;

    if (truthy(flag)) {
      $header.on(Header.EVT_LEVEL_UP, function (evt) {
        if (anyOf(falsy(_.header.isUsableLevelUpBtn()), truthy(_.loading.isLoading))) return;

        if (falsy(_.isCompleteSetBaseStat)) { // 2022.01
          _.global.alert(ALERT.CAN_LEVELUP_AFTER_INIT_BASE_STAT); // '베이스 스탯 포인트 분배 후에 레벨업하실 수 있습니다.'
          return;
        }

        if (_.statData.remainStat > 0) {
          _.global.alert(ALERT.CAN_LEVELUP_AFTER_EXHAUST_REMAIN_STAT); // '남은 스탯을 모두 사용하셔야 레벨업하실 수 있습니다.'
          return;
        }
        if (_.statData.level >= _.statData.targetLevel)  {
          _.global.alert("목표 레벨까지 모두 레벨업하셨습니다."); // 2022.01
          // _.global.alert(ALERT.CAN_LEVELUP_AFTER_EXHAUST_REMAIN_STAT); // '남은 스탯을 모두 사용하셔야 레벨업하실 수 있습니다.'
          return;
        }

        const sendData = {
          'classId': parseInt10(_.option.classId),
          'level': parseInt10(_.option.level),
          'targetLevel': parseInt10(_.option.targetLevel),
          'hp': parseStrIntToInt(_.statData.HP),
          'mp': parseStrIntToInt(_.statData.MP),
          'currentStat': {
            'STR': parseInt10(_.statData.STR),
            'INT': parseInt10(_.statData.INT),
            'DEX': parseInt10(_.statData.DEX),
            'WIS': parseInt10(_.statData.WIS),
            'CON': parseInt10(_.statData.CON),
            'CHA': parseInt10(_.statData.CHA)
          }
        };

        _.callCalculateApiByLevelUp(sendData);
      });

      $header.on(Header.EVT_CHECK_ELIXIR_CHECKBOX, function (evt) {
        console.log('EVT_CHECK_ELIXIR_CHECKBOX');

        if (falsy(_.header.isCheckedElixirStatCheckBox())) {

          if (allOf(truthy(_.isUsedElixirAtCurrentLevel), _.statData.elixirStat > 0)) {
            _.global.alert(ALERT.CAN_PROCESS_AFTER_EXHAUST_ELIXIR_STAT); // '엘릭서의 스탯을 모두 사용하셔야 다음 진행을 하실 수 있습니다.'

            _.header.setElixirStatCheckBoxChecked(true);
            _.statData.elixirUseYN = true;

          } else {
            _.header.activateElixirStatField(false);

            _.statData.elixirUseYN = false;

          }

        } else {
          _.statData.elixirUseYN = true;
        }

        _.changeSectionBtnsStatus();
      });

    } else {

      $header
        .off(Header.EVT_LEVEL_UP)
        .off(Header.EVT_CHECK_ELIXIR_CHECKBOX);
    }
  }

  callCalculateApi(options) {
    // plus : { type, pointType, sendData, consumeStatName }
    // minus : { type, pointType, sendData }

    const _ = this,
      opt = _.option,
      model = _.model;

    if (truthy(_.loading.isLoading)) return;

    calculateStat({
      apiDomain: opt.apiDomain,
      classId: opt.classId,
      sendData: options.sendData,
      beforeSend: () => _.loading.start()

    }).then((data, textStatus, jqXHR) => {
      console.log('calculateStat - data :', data);

      _.loading.end();

      const sub = data.formattedSubStat,
        attribute = allOf(isDefined(data), isDefined(sub)) ? sub.attribute : null;

      let receivedStats = null,
        changedStats = null;

      switch (options.type) {
        case 'plus' :
          if (options.pointType === 'remainStat') {
            _.statData.remainStat--;

          } else if (options.pointType === 'elixirStat') {
            _.statData.elixirStat--;
          }

          receivedStats = {
            'type': model.DEVICE_TYPE,
            'classType': _.option.classId,

            // 'point' : (data) ? getDefined(data.remainStat, '0') : '-',
            'level': _.statData.level,
            'targetLevel': _.statData.targetLevel,

            'HP': getDefined(data.hp, '0'),
            'MP': getDefined(data.mp, '0'),

            'STR': parseInt10(getDefined(data.mainStat.STR, 0)),
            'DEX': parseInt10(getDefined(data.mainStat.DEX, 0)),
            'INT': parseInt10(getDefined(data.mainStat.INT, 0)),
            'CON': parseInt10(getDefined(data.mainStat.CON, 0)),
            'WIS': parseInt10(getDefined(data.mainStat.WIS, 0)),
            'CHA': parseInt10(getDefined(data.mainStat.CHA, 0)),

            // STR
            'DAMAGE_SHORT': getDefined(sub.STR.damageShort, '0'),
            'HIT_SHORT': getDefined(sub.STR.hitShort, '0'),
            'FATAL_SHORT': getDefined(sub.STR.fatalShort, '0'),
            'WEIGHT': getDefined(sub.STR.weight, '0'),

            // INT
            'DAMAGE_WIZ': getDefined(sub.INT.damageWiz, '0'),
            'HIT_WIZ': getDefined(sub.INT.hitWiz, '0'),
            'FATAL_WIZ': getDefined(sub.INT.fatalWiz, '0'),
            'MB': getDefined(sub.INT.mb, '0'),
            'MP_MINUS': getDefined(sub.INT.mpMinus, '0'),

            // DEX
            'DAMAGE_LONG': getDefined(sub.DEX.damageLong, '0'),
            'HIT_LONG': getDefined(sub.DEX.hitLong, '0'),
            'FATAL_LONG': getDefined(sub.DEX.fatalLong, '0'),
            'AC': getDefined(sub.DEX.ac, '0'),
            'ER': getDefined(sub.DEX.er, '0'),

            // WIS
            'LEVELUP_MP_PLUS_MIN': getDefined(sub.WIS.levelupMpPlus.min, '0'),
            'LEVELUP_MP_PLUS_MAX': getDefined(sub.WIS.levelupMpPlus.max, '0'),
            'MP_RECOVER_TIC': getDefined(sub.WIS.mpRecoverTic, '0'),
            'MP_RECOVER_LIQUOR': getDefined(sub.WIS.mpRecoverLiquor, '0'),
            'MR': getDefined(sub.WIS.mr, '0'),

            // CON
            'LEVELUP_HP_PLUS_MIN': getDefined(sub.CON.hpPlus.min, '0'),
            'LEVELUP_HP_PLUS_MAX': getDefined(sub.CON.hpPlus.max, '0'),
            'HP_RECOVER_TIC_MIN': getDefined(sub.CON.hpRecoverTic.min, '0'),
            'HP_RECOVER_TIC_MAX': getDefined(sub.CON.hpRecoverTic.max, '0'),
            'HP_RECOVER_LIQUOR': getDefined(sub.CON.hpRecoverLiquor, '0'),
            // CON WEIGHT === STR WEIGHT

            // CHA  // 20211206
            'CHA_HIT_SIKII': getDefined(sub.CHA.hitSkill, '0'),
            'CHA_HIT_SUMMON': getDefined(sub.CHA.hitSummon, '0'),
            'CHA_HIT_DRAGON': getDefined(sub.CHA.hitDragon, '0'),
            'CHA_HIT_FEAR': getDefined(sub.CHA.hitFear, '0'),
            'CHA_SKILL_TIME_REDUCTION': getDefined(sub.CHA.skillTimeReduction, '0'),
            'CHA_STATUS_TIME_REDUCTION': getDefined(sub.CHA.statusTimeReduction, '0'),

            // attribute
            'FIRE': isDefined(attribute) ? getDefined(attribute.fire, '0') : '0',
            'WATER': isDefined(attribute) ? getDefined(attribute.water, '0') : '0',
            'STORM': isDefined(attribute) ? getDefined(attribute.storm, '0') : '0',
            'LAND': isDefined(attribute) ? getDefined(attribute.land, '0') : '0',
            'HIT_SKILL': isDefined(attribute) ? getDefined(attribute.hitSkill, '0') : '0',
            'RES_SKILL': isDefined(attribute) ? getDefined(attribute.resSkill, '0') : '0',
            'HIT_SUMMON': isDefined(attribute) ? getDefined(attribute.hitSummon, '0') : '0',
            'RES_SUMMON': isDefined(attribute) ? getDefined(attribute.resSummon, '0') : '0',
            'HIT_DRAGON': isDefined(attribute) ? getDefined(attribute.hitDragon, '0') : '0',
            'RES_DRAGON': isDefined(attribute) ? getDefined(attribute.resDragon, '0') : '0',
            'HIT_FEAR': isDefined(attribute) ? getDefined(attribute.hitFear, '0') : '0',
            'RES_FEAR': isDefined(attribute) ? getDefined(attribute.resFear, '0') : '0',

            'remainStat': _.statData.remainStat,
            'remainTotalStat': _.statData.remainTotalStat,
            'elixirStat': _.statData.elixirStat,
            'elixirTotalStat': _.statData.elixirTotalStat,

            'elixirUseYN': _.header.isCheckedElixirStatCheckBox() // elixir stat checkbox checked: true or false
          };

          changedStats = getChangedStats(_.statDataFirstAtLevel, receivedStats);

          if (options.pointType === 'remainStat') {
            _.header.setRemainStat(receivedStats.remainStat);

          } else if (options.pointType === 'elixirStat') {
            _.header.setElixirStat(receivedStats.elixirStat);

            _.isUsedElixirAtCurrentLevel = true;
          }

          _.header.setHpMp(changedStats);

          _.section.setChangedStat(_.isCompleteSetBaseStat, changedStats, receivedStats);
          _.section.setStatValueColor(_.statData.level);

          _.statData = receivedStats;

          _.consumedPoint++;

          _.lastConsumedStatName = options.consumeStatName || '';

          break;

        case 'minus' :
          _.statData.remainStat++;

          receivedStats = {
            'type': model.DEVICE_TYPE,
            'classType': _.option.classId,

            // 'point' : getDefined(data.remainStat, '0'),
            'level': _.statData.level,
            'targetLevel': _.statData.targetLevel,

            'HP': getDefined(data.hp, '0'),
            'MP': getDefined(data.mp, '0'),

            'STR': parseInt10(getDefined(data.mainStat.STR, '0')),
            'DEX': parseInt10(getDefined(data.mainStat.DEX, '0')),
            'INT': parseInt10(getDefined(data.mainStat.INT, '0')),
            'CON': parseInt10(getDefined(data.mainStat.CON, '0')),
            'WIS': parseInt10(getDefined(data.mainStat.WIS, '0')),
            'CHA': parseInt10(getDefined(data.mainStat.CHA, '0')),

            // STR
            'DAMAGE_SHORT': getDefined(sub.STR.damageShort, '0'),
            'HIT_SHORT': getDefined(sub.STR.hitShort, '0'),
            'FATAL_SHORT': getDefined(sub.STR.fatalShort, '0'),
            'WEIGHT': getDefined(sub.STR.weight, '0'),

            // INT
            'DAMAGE_WIZ': getDefined(sub.INT.damageWiz, '0'),
            'HIT_WIZ': getDefined(sub.INT.hitWiz, '0'),
            'FATAL_WIZ': getDefined(sub.INT.fatalWiz, '0'),
            'MB': getDefined(sub.INT.mb, '0'),
            'MP_MINUS': getDefined(sub.INT.mpMinus, '0'),

            // DEX
            'DAMAGE_LONG': getDefined(sub.DEX.damageLong, '0'),
            'HIT_LONG': getDefined(sub.DEX.hitLong, '0'),
            'FATAL_LONG': getDefined(sub.DEX.fatalLong, '0'),
            'AC': getDefined(sub.DEX.ac, '0'),
            'ER': getDefined(sub.DEX.er, '0'),

            // WIS
            'LEVELUP_MP_PLUS_MIN': getDefined(sub.WIS.levelupMpPlus.min, '0'),
            'LEVELUP_MP_PLUS_MAX': getDefined(sub.WIS.levelupMpPlus.max, '0'),
            'MP_RECOVER_TIC': getDefined(sub.WIS.mpRecoverTic, '0'),
            'MP_RECOVER_LIQUOR': getDefined(sub.WIS.mpRecoverLiquor, '0'),
            'MR': getDefined(sub.WIS.mr, '0'),

            // CON
            'LEVELUP_HP_PLUS_MIN': getDefined(sub.CON.hpPlus.min, '0'),
            'LEVELUP_HP_PLUS_MAX': getDefined(sub.CON.hpPlus.max, '0'),
            'HP_RECOVER_TIC_MIN': getDefined(sub.CON.hpRecoverTic.min, '0'),
            'HP_RECOVER_TIC_MAX': getDefined(sub.CON.hpRecoverTic.max, '0'),
            'HP_RECOVER_LIQUOR': getDefined(sub.CON.hpRecoverLiquor, '0'),
            // CON WEIGHT === STR WEIGHT

            // CHA  // 20211206
            'CHA_HIT_SIKII': getDefined(sub.CHA.hitSkill, '0'),
            'CHA_HIT_SUMMON': getDefined(sub.CHA.hitSummon, '0'),
            'CHA_HIT_DRAGON': getDefined(sub.CHA.hitDragon, '0'),
            'CHA_HIT_FEAR': getDefined(sub.CHA.hitFear, '0'),
            'CHA_SKILL_TIME_REDUCTION': getDefined(sub.CHA.skillTimeReduction, '0'),
            'CHA_STATUS_TIME_REDUCTION': getDefined(sub.CHA.statusTimeReduction, '0'),

            // attribute
            'FIRE': isDefined(attribute) ? getDefined(attribute.fire, '0') : '0',
            'WATER': isDefined(attribute) ? getDefined(attribute.water, '0') : '0',
            'STORM': isDefined(attribute) ? getDefined(attribute.storm, '0') : '0',
            'LAND': isDefined(attribute) ? getDefined(attribute.land, '0') : '0',
            'HIT_SKILL': isDefined(attribute) ? getDefined(attribute.hitSkill, '0') : '0',
            'RES_SKILL': isDefined(attribute) ? getDefined(attribute.resSkill, '0') : '0',
            'HIT_SUMMON': isDefined(attribute) ? getDefined(attribute.hitSummon, '0') : '0',
            'RES_SUMMON': isDefined(attribute) ? getDefined(attribute.resSummon, '0') : '0',
            'HIT_DRAGON': isDefined(attribute) ? getDefined(attribute.hitDragon, '0') : '0',
            'RES_DRAGON': isDefined(attribute) ? getDefined(attribute.resDragon, '0') : '0',
            'HIT_FEAR': isDefined(attribute) ? getDefined(attribute.hitFear, '0') : '0',
            'RES_FEAR': isDefined(attribute) ? getDefined(attribute.resFear, '0') : '0',

            'remainStat': _.statData.remainStat,
            'remainTotalStat': _.statData.remainTotalStat,
            'elixirStat': _.statData.elixirStat,
            'elixirTotalStat': _.statData.elixirTotalStat,

            'elixirUseYN': _.header.isCheckedElixirStatCheckBox()
          };

          console.log('receivedStats :', receivedStats);

          changedStats = getChangedStats(_.statData, receivedStats);
          console.log('minus - changedStat :', changedStats);

          _.header.setRemainStat(receivedStats.remainStat);
          _.header.setHpMp(changedStats);

          _.section.setChangedStat(_.isCompleteSetBaseStat, changedStats, receivedStats, _.statDataFirstAtLevel, _.defaultStatsForDiff);
          _.section.setStatValueColor(_.statData.level);

          _.statData = receivedStats;
          _.consumedPoint--;

          break;
      }

      if (_.statData.remainStat > 0 && _.statData.level < _.statData.targetLevel ) { // 2022.01 targetLevel
        console.log("=> StatSimulator.js  if(.statData.remainStat > 0 &&_.statData.level < _.statData.targetLevel )  ");
        _.header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);

      } else {
        console.log('callCalculateApi remain stat is 0');

        if (falsy(_.isCompleteSetBaseStat) && (_.statData.targetLevel > 50)) {
          console.log('show _confirmBaseStatModal');

          window.setTimeout(function () {
            _.confirmDistributeBaseStat();
          }, 50);
        }

        if (falsy(_.header.isCheckedElixirStatCheckBox())) {
          console.log('checkbox not checked');

        } else {
          console.log('checkbox checked');

          if (_.statData.elixirStat <= 0) {
            console.log('checkbox checked. elixir is 0.');

            if (falsy(_.isCompleteSetBaseStat) && (_.statData.targetLevel > 50)) {
              console.log('show _confirmBaseStatModal');

              window.setTimeout(function () {
                _.confirmDistributeBaseStat();
              }, 50);

            } else {
              console.log('_.isCompleteSetBaseStat is true');
            }

          } else {
            console.log('-checkbox checked. elixir > 0.');

            if (falsy(isLevelCanConsumeElixirStat( parseInt(_.statData.level - model.LEVEL_INIT)))) { // 2019.11
              console.log(`can not consume elixir at ${_.statData.level} level`);
              _.header.setLevelUpBtnUsable(true, _.model.DEVICE_TYPE);

            } else {
              console.log(`can consume elixir at ${_.statData.level} level`);
            }
          }
        }
      }

      _.changeSectionBtnsStatus();

      _.header.setHpMp(_.statData);

      _.focusWrap(_.statData.type);

    }).catch((err) => {
      console.log('calculateStat - error :', err);

      _.loading.end();

      _.focusWrap(_.statData.type);

      if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_CALCULATE_STAT); // '현재 스탯 계산을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });
  }

  callCalculateApiByConfirmBaseStat(sendData) {
    console.log('callCalculateApiByConfirmBaseStat sendData :', sendData);

    const _ = this,
      opt = _.option,
      header = _.header,
      section = _.section;

    if (truthy(_.loading.isLoading)) return;

    calculateStat({
      apiDomain: opt.apiDomain,
      classId: opt.classId,
      sendData: sendData,
      beforeSend: () => _.loading.start()

    }).then((data, textStatus, jqXHR) => {
      console.log('callCalculateApiByConfirmBaseStat() - data :', data);

      _.loading.end();

      const sub = data.formattedSubStat,
        attribute = allOf(isDefined(data), isDefined(sub)) ? sub.attribute : null;

      const receivedStats = {
        'page': _.option.page,

        'type': _.model.DEVICE_TYPE,
        'classType': parseInt10(sendData.classId),

        'level': parseInt10(sendData.level),
        'targetLevel': parseInt10(sendData.targetLevel),

        'HP': getDefined(data.hp, '0'),
        'MP': getDefined(data.mp, '0'),

        'STR': parseInt10(getDefined(data.mainStat.STR, '0')),
        'DEX': parseInt10(getDefined(data.mainStat.DEX, '0')),
        'INT': parseInt10(getDefined(data.mainStat.INT, '0')),
        'CON': parseInt10(getDefined(data.mainStat.CON, '0')),
        'WIS': parseInt10(getDefined(data.mainStat.WIS, '0')),
        'CHA': parseInt10(getDefined(data.mainStat.CHA, '0')),

        // STR
        'DAMAGE_SHORT': getDefined(sub.STR.damageShort, '0'),
        'HIT_SHORT': getDefined(sub.STR.hitShort, '0'),
        'FATAL_SHORT': getDefined(sub.STR.fatalShort, '0'),
        'WEIGHT': getDefined(sub.STR.weight, '0'),

        // INT
        'DAMAGE_WIZ': getDefined(sub.INT.damageWiz, '0'),
        'HIT_WIZ': getDefined(sub.INT.hitWiz, '0'),
        'FATAL_WIZ': getDefined(sub.INT.fatalWiz, '0'),
        'MB': getDefined(sub.INT.mb, '0'),
        'MP_MINUS': getDefined(sub.INT.mpMinus, '0'),

        // DEX
        'DAMAGE_LONG': getDefined(sub.DEX.damageLong, '0'),
        'HIT_LONG': getDefined(sub.DEX.hitLong, '0'),
        'FATAL_LONG': getDefined(sub.DEX.fatalLong, '0'),
        'AC': getDefined(sub.DEX.ac, '0'),
        'ER': getDefined(sub.DEX.er, '0'),

        // WIS
        'LEVELUP_MP_PLUS_MIN': getDefined(sub.WIS.levelupMpPlus.min, '0'),
        'LEVELUP_MP_PLUS_MAX': getDefined(sub.WIS.levelupMpPlus.max, '0'),
        'MP_RECOVER_TIC': getDefined(sub.WIS.mpRecoverTic, '0'),
        'MP_RECOVER_LIQUOR': getDefined(sub.WIS.mpRecoverLiquor, '0'),
        'MR': getDefined(sub.WIS.mr, '0'),

        // CON
        'LEVELUP_HP_PLUS_MIN': getDefined(sub.CON.hpPlus.min, '0'),
        'LEVELUP_HP_PLUS_MAX': getDefined(sub.CON.hpPlus.max, '0'),
        'HP_RECOVER_TIC_MIN': getDefined(sub.CON.hpRecoverTic.min, '0'),
        'HP_RECOVER_TIC_MAX': getDefined(sub.CON.hpRecoverTic.max, '0'),
        'HP_RECOVER_LIQUOR': getDefined(sub.CON.hpRecoverLiquor, '0'),
        // CON WEIGHT === STR WEIGHT

        // CHA  // 20211206
        'CHA_HIT_SIKII': getDefined(sub.CHA.hitSkill, '0'),
        'CHA_HIT_SUMMON': getDefined(sub.CHA.hitSummon, '0'),
        'CHA_HIT_DRAGON': getDefined(sub.CHA.hitDragon, '0'),
        'CHA_HIT_FEAR': getDefined(sub.CHA.hitFear, '0'),
        'CHA_SKILL_TIME_REDUCTION': getDefined(sub.CHA.skillTimeReduction, '0'),
        'CHA_STATUS_TIME_REDUCTION': getDefined(sub.CHA.statusTimeReduction, '0'),

        // attribute
        'FIRE': isDefined(attribute) ? getDefined(attribute.fire, '0') : '0',
        'WATER': isDefined(attribute) ? getDefined(attribute.water, '0') : '0',
        'STORM': isDefined(attribute) ? getDefined(attribute.storm, '0') : '0',
        'LAND': isDefined(attribute) ? getDefined(attribute.land, '0') : '0',
        'HIT_SKILL': isDefined(attribute) ? getDefined(attribute.hitSkill, '0') : '0',
        'RES_SKILL': isDefined(attribute) ? getDefined(attribute.resSkill, '0') : '0',
        'HIT_SUMMON': isDefined(attribute) ? getDefined(attribute.hitSummon, '0') : '0',
        'RES_SUMMON': isDefined(attribute) ? getDefined(attribute.resSummon, '0') : '0',
        'HIT_DRAGON': isDefined(attribute) ? getDefined(attribute.hitDragon, '0') : '0',
        'RES_DRAGON': isDefined(attribute) ? getDefined(attribute.resDragon, '0') : '0',
        'HIT_FEAR': isDefined(attribute) ? getDefined(attribute.hitFear, '0') : '0',
        'RES_FEAR': isDefined(attribute) ? getDefined(attribute.resFear, '0') : '0',

        'remainStat': parseInt10(_.statData.remainStat),
        'remainTotalStat': parseInt10(_.statData.remainTotalStat),
        'elixirStat': parseInt10(_.statData.elixirStat),
        'elixirTotalStat': parseInt10(_.statData.elixirTotalStat),

        'elixirUseYN': header.isCheckedElixirStatCheckBox()
      };

      _.statData = receivedStats;
      _.statDataFirstAtLevel = $.extend({}, _.statData);

      _.consumedPoint = 0;

      _.isCompleteSetBaseStat = true;

      console.log('_callCalculateApiByConfirmBaseStat receivedStats :', receivedStats);

      header.setLevel(receivedStats.level);
      header.setRemainStat(receivedStats.remainStat);
      header.setRemainTotalStat(receivedStats.remainTotalStat);
      header.setElixirStat(receivedStats.elixirStat);
      header.setElixirTotalStat(receivedStats.elixirTotalStat);
      header.setHpMp(receivedStats);

      section.reset(receivedStats);

      _.changeSectionBtnsStatus();

      const changedStats = getChangedStats(_.statData, _.defaultStatsForDiff);
      section.setHighlightChangedStats(changedStats); // add '.on' class to changed stats
      section.setStatValueColor(_.statData.level); // STR, INT, DEX, WIS, CON, CHA

      _.focusWrap(_.statData.type);

    }).catch((err) => {
      console.log('callCalculateApiByConfirmBaseStat() - error :', err);

      _.loading.end();

      _.focusWrap(_.statData.type);

      if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_CALCULATE_STAT); // '현재 스탯 계산을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });
  }

  callCalculateApiByLevelUp(sendData) {
    var _ = this,
      statData = _.statData;

    console.log('callCalculateApiByLevelUp - statData :', statData);

    if (truthy(_.loading.isLoading)) return;

    calculateStatByLevelUp({
      apiDomain: _.option.apiDomain,
      classId: _.option.classId,
      level: statData.level + 1,
      targetLevel: _.option.targetLevel,
      sendData: sendData,
      beforeSend: () => _.loading.start()

    }).then((data, textStatus, jqXHR) => {
      console.log('calculateStatByLevelUp - data :', data);

      _.loading.end();

      const sub = data.formattedSubStat,
        attribute = allOf(isDefined(data), isDefined(sub)) ? sub.attribute : null,
        receivedStats = {
          'page': _.option.page,

          'type': _.model.DEVICE_TYPE,
          'classType': _.option.classId,

          'STR': parseInt10(getDefined(data.mainStat.STR, '0')),
          'DEX': parseInt10(getDefined(data.mainStat.DEX, '0')),
          'INT': parseInt10(getDefined(data.mainStat.INT, '0')),
          'CON': parseInt10(getDefined(data.mainStat.CON, '0')),
          'WIS': parseInt10(getDefined(data.mainStat.WIS, '0')),
          'CHA': parseInt10(getDefined(data.mainStat.CHA, '0')),

          // 'point' : getDefined(data.remainStat, '0'),
          'level': parseInt10(data.level),
          'targetLevel': parseInt10(data.targetLevel),
          'HP': getDefined(data.hp, '0'),
          'MP': getDefined(data.mp, '0'),

          // STR
          'DAMAGE_SHORT': getDefined(sub.STR.damageShort, '0'),
          'HIT_SHORT': getDefined(sub.STR.hitShort, '0'),
          'FATAL_SHORT': getDefined(sub.STR.fatalShort, '0'),
          'WEIGHT': getDefined(sub.STR.weight, '0'),

          // INT
          'DAMAGE_WIZ': getDefined(sub.INT.damageWiz, '0'),
          'HIT_WIZ': getDefined(sub.INT.hitWiz, '0'),
          'FATAL_WIZ': getDefined(sub.INT.fatalWiz, '0'),
          'MB': getDefined(sub.INT.mb, '0'),
          'MP_MINUS': getDefined(sub.INT.mpMinus, '0'),

          // DEX
          'DAMAGE_LONG': getDefined(sub.DEX.damageLong, '0'),
          'HIT_LONG': getDefined(sub.DEX.hitLong, '0'),
          'FATAL_LONG': getDefined(sub.DEX.fatalLong, '0'),
          'AC': getDefined(sub.DEX.ac, '0'),
          'ER': getDefined(sub.DEX.er, '0'),

          // WIS
          'LEVELUP_MP_PLUS_MIN': getDefined(sub.WIS.levelupMpPlus.min, '0'),
          'LEVELUP_MP_PLUS_MAX': getDefined(sub.WIS.levelupMpPlus.max, '0'),
          'MP_RECOVER_TIC': getDefined(sub.WIS.mpRecoverTic, '0'),
          'MP_RECOVER_LIQUOR': getDefined(sub.WIS.mpRecoverLiquor, '0'),
          'MR': getDefined(sub.WIS.mr, '0'),

          // CON
          'LEVELUP_HP_PLUS_MIN': getDefined(sub.CON.hpPlus.min, '0'),
          'LEVELUP_HP_PLUS_MAX': getDefined(sub.CON.hpPlus.max, '0'),
          'HP_RECOVER_TIC_MIN': getDefined(sub.CON.hpRecoverTic.min, '0'),
          'HP_RECOVER_TIC_MAX': getDefined(sub.CON.hpRecoverTic.max, '0'),
          'HP_RECOVER_LIQUOR': getDefined(sub.CON.hpRecoverLiquor, '0'),
          // CON WEIGHT === STR WEIGHT

          // CHA  // 20211206
          'CHA_HIT_SIKII': getDefined(sub.CHA.hitSkill, '0'),
          'CHA_HIT_SUMMON': getDefined(sub.CHA.hitSummon, '0'),
          'CHA_HIT_DRAGON': getDefined(sub.CHA.hitDragon, '0'),
          'CHA_HIT_FEAR': getDefined(sub.CHA.hitFear, '0'),
          'CHA_SKILL_TIME_REDUCTION': getDefined(sub.CHA.skillTimeReduction, '0'),
          'CHA_STATUS_TIME_REDUCTION': getDefined(sub.CHA.statusTimeReduction, '0'),

          // attribute
          'FIRE': isDefined(attribute) ? getDefined(attribute.fire, '0') : '0',
          'WATER': isDefined(attribute) ? getDefined(attribute.water, '0') : '0',
          'STORM': isDefined(attribute) ? getDefined(attribute.storm, '0') : '0',
          'LAND': isDefined(attribute) ? getDefined(attribute.land, '0') : '0',
          'HIT_SKILL': isDefined(attribute) ? getDefined(attribute.hitSkill, '0') : '0',
          'RES_SKILL': isDefined(attribute) ? getDefined(attribute.resSkill, '0') : '0',
          'HIT_SUMMON': isDefined(attribute) ? getDefined(attribute.hitSummon, '0') : '0',
          'RES_SUMMON': isDefined(attribute) ? getDefined(attribute.resSummon, '0') : '0',
          'HIT_DRAGON': isDefined(attribute) ? getDefined(attribute.hitDragon, '0') : '0',
          'RES_DRAGON': isDefined(attribute) ? getDefined(attribute.resDragon, '0') : '0',
          'HIT_FEAR': isDefined(attribute) ? getDefined(attribute.hitFear, '0') : '0',
          'RES_FEAR': isDefined(attribute) ? getDefined(attribute.resFear, '0') : '0',

          'remainStat': statData.remainStat + 1,
          'remainTotalStat': statData.remainTotalStat + 1,
          'elixirStat': statData.elixirStat,
          'elixirTotalStat': statData.elixirTotalStat,

          'elixirUseYN': _.header.isCheckedElixirStatCheckBox()
        };

      console.log('receivedStats :', receivedStats);

      /* 2019.11
      if (isLevelCanConsumeElixirStat( parseInt(receivedStats.level - _.model.LEVEL_INIT), _.model.PER_LEVEL_PLUS_ELIXIR_POINT)) {
        receivedStats.elixirStat++;
        receivedStats.elixirTotalStat++;
      } */

      /* 2021.12 ~ 2022.01 */
      if(isLevelCanConsumeElixirStat( parseInt(receivedStats.level - _.model.LEVEL_INIT))){
        let _getPlusElixirPoint = getPlusElixirPointByLevel(parseInt(receivedStats.level), parseInt(_.model.LEVEL_INIT), _.model.PLUS_ELIXIR_POINT_BY_LEVEL);
        console.log('# _getPlusElixirPoint : ', _getPlusElixirPoint);
        receivedStats.elixirStat = receivedStats.elixirStat + _getPlusElixirPoint;
        receivedStats.elixirTotalStat = receivedStats.elixirTotalStat + _getPlusElixirPoint;
      }

      if (receivedStats.level > _.model.LEVEL_USABLE_ELIXIR_POINT) { // 100
        return;
        // receivedStats.elixirStat = 0;
        // receivedStats.elixirTotalStat = 0;
      }

      _.header.setRemainStat(receivedStats.remainStat);
      _.header.setRemainTotalStat(receivedStats.remainTotalStat);
      _.header.setElixirStat(receivedStats.elixirStat);
      _.header.setElixirTotalStat(receivedStats.elixirTotalStat);
      _.header.setLevel(receivedStats.level);
      _.header.setHpMp(receivedStats);
      _.header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);

      _.section.reset(receivedStats);

      _.statData = receivedStats;
      _.statDataFirstAtLevel = $.extend({}, _.statData);
      _.consumedPoint = 0;

      _.isUsedElixirAtCurrentLevel = false;

      _.changeSectionBtnsStatus();

      const changedStats = getChangedStats(_.statData, _.defaultStatsForDiff);
      _.section.setHighlightChangedStats(changedStats); // add '.on' class to changed stats
      _.section.setStatValueColor(_.statData.level); // STR, INT, DEX, WIS, CON, CHA

      _.focusWrap(_.statData.type);

    }).catch((err) => {
      console.log('calculateStatByLevelUp - error :', err);

      _.loading.end();

      _.focusWrap(_.statData.type);

      if (falsy(handleApiError(err.jqXHR))) _.global.alert(ALERT.FAIL_CALCULATE_STAT); // '현재 스탯 계산을 할 수 없습니다. 잠시 후, 다시 시도해주세요.'
    });
  }

  confirmDistributeBaseStat() {
    const _ = this;

    console.log('set confirm base stat modal');

    const isConfirmDistributeBaseStat = _.global.confirm(ALERT.COMPLETE_DISTRIBUTE_BASE_STAT); // 베이스 스탯을 모두 분배하셨습니다. 이제 레벨업으로 원하는 스탯에 보너스 스탯 포인트를 분배하실 수 있습니다.

    if (truthy(isConfirmDistributeBaseStat)) {
      _.callCalculateApiByConfirmBaseStat({
        'classId': parseInt10(_.option.classId),
        'level': parseInt10(_.statData.level),
        'targetLevel': parseInt10(_.option.targetLevel),
        'hp': parseInt10(_.statData.HP),
        'mp': parseInt10(_.statData.MP),
        'currentStat': {
          'STR': parseInt10(_.statData.STR),
          'INT': parseInt10(_.statData.INT),
          'DEX': parseInt10(_.statData.DEX),
          'WIS': parseInt10(_.statData.WIS),
          'CON': parseInt10(_.statData.CON),
          'CHA': parseInt10(_.statData.CHA)
        },
        'differenceStat': {'STR': 0, 'INT': 0, 'DEX': 0, 'WIS': 0, 'CON': 0, 'CHA': 0},
        'completeBaseStat': true
      });

    } else {
      _.isCompleteSetBaseStat = false;

      _.header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);

      if (_.lastConsumedStatName !== '') _.minusStat(_.lastConsumedStatName);
    }
  }

  setSectionEvents(flag) {
    const _ = this,
      $section = $(_.section);

    if ($section.length <= 0) return;

    if (truthy(flag)) {
      $section.on(Section.EVT_PLUS_STAT, function (evt) {
        if (truthy(_.loading.isLoading)) return;

        _.plusStat(evt.statName);
      });

      $section.on(Section.EVT_MINUS_STAT, function (evt) {
        if (truthy(_.loading.isLoading)) return;

        _.minusStat(evt.statName);
      });

    } else {
      $section
        .off(Section.EVT_PLUS_STAT)
        .off(Section.EVT_MINUS_STAT);
    }
  }

  plusStat(statName) {
    const _ = this;

    const stats = _.statData,
      sendData = {
        'classId': parseInt10(_.option.classId),
        'level': parseInt10(stats.level),
        'targetLevel': parseInt10(stats.targetLevel),
        'hp': parseStrIntToInt(stats.HP),
        'mp': parseStrIntToInt(stats.MP),
        'currentStat': {
          'STR': parseInt10(stats.STR),
          'CON': parseInt10(stats.CON),
          'DEX': parseInt10(stats.DEX),
          'INT': parseInt10(stats.INT),
          'WIS': parseInt10(stats.WIS),
          'CHA': parseInt10(stats.CHA)
        },
        'differenceStat': {
          'STR': (statName === 'STR') ? 1 : 0,
          'INT': (statName === 'INT') ? 1 : 0,
          'DEX': (statName === 'DEX') ? 1 : 0,
          'WIS': (statName === 'WIS') ? 1 : 0,
          'CON': (statName === 'CON') ? 1 : 0,
          'CHA': (statName === 'CHA') ? 1 : 0
        },
        'completeBaseStat': false
      };

    if (_.statData.remainStat > 0) {
      console.log('remainStat > 0');

      _.callCalculateApi({
        type: 'plus',
        pointType: 'remainStat',
        sendData: sendData,
        consumeStatName: statName
      });

    } else {
      console.log('remainStat <= 0');

      if (falsy(_.header.isCheckedElixirStatCheckBox())) {
        // can not use elixir point
        _.global.alert(ALERT.REMAIN_STAT_ZERO); // '사용하실 수 있는 스탯 포인트를 모두 사용하셨습니다.'

      } else {
        // can use elixir point
        if (_.statData.elixirStat <= 0) {
          _.global.alert(ALERT.REMAIN_STAT_ZERO); // '사용하실 수 있는 스탯 포인트를 모두 사용하셨습니다.'

        } else {
          if (falsy(isLevelCanConsumeElixirStat( parseInt(stats.level - _.model.LEVEL_INIT) ))) { // 2019.11
            _.global.alert(ALERT.IMPOSSIBLE_LEVEL_CONSUME_ELIXIR_STAT); // '엘릭서 스탯 포인트를 사용할 수 없는 레벨입니다.'

            return;
          }

          _.callCalculateApi({
            type: 'plus',
            pointType: 'elixirStat',
            sendData: sendData,
            consumeStatName: statName
          });
        }
      }
    }
  }

  minusStat(statName) {
    const _ = this;

    if (not(isString)(statName)) throw new Error('statName parameter type must be String.');

    if (_.consumedPoint <= 0) {
      _.global.alert(ALERT.NO_UNDO_STAT); // '되돌릴 수 있는 스탯 포인트가 없습니다.'
      return;
    }

    const stat = _.statData,
      sendData = {
        'classId': parseInt10(_.option.classId),
        'level': parseInt10(stat.level),
        'targetLevel': parseInt10(stat.targetLevel),
        'hp': parseStrIntToInt(stat.HP),
        'mp': parseStrIntToInt(stat.MP),
        'currentStat': {
          'STR': parseInt10(stat.STR),
          'CON': parseInt10(stat.CON),
          'DEX': parseInt10(stat.DEX),
          'INT': parseInt10(stat.INT),
          'WIS': parseInt10(stat.WIS),
          'CHA': parseInt10(stat.CHA)
        },
        'differenceStat': {
          'STR': (statName === 'STR') ? -1 : 0,
          'INT': (statName === 'INT') ? -1 : 0,
          'DEX': (statName === 'DEX') ? -1 : 0,
          'WIS': (statName === 'WIS') ? -1 : 0,
          'CON': (statName === 'CON') ? -1 : 0,
          'CHA': (statName === 'CHA') ? -1 : 0
        },
        'completeBaseStat': false
      };

    _.callCalculateApi({
      type: 'minus',
      pointType: 'remainStat',
      sendData: sendData
    });
  }

  changeSectionBtnsStatus() {
    const _ = this,
      header = _.header,
      section = _.section,
      statFirst = _.statDataFirstAtLevel;

    section.activateAllMinusBtns(false);
    section.activateAllPlusBtns(false);

    var remainStat = parseStrIntToInt(_.statData.remainStat),
      elixirStat = parseStrIntToInt(_.statData.elixirStat);

    let isRemainLevel =  _.statData.level <= _.statData.targetLevel; // 2022.01
    // if (_.statData.level >= _.model.targetLevel) header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);  // 2022.01 targetLevel
    console.log('=> StatSimulator.js changeSectionBtnsStatus() _.statData.level >= _.statData.targetLevel', _.statData.level >= _.statData.targetLevel );



    if (remainStat > 0) {
      console.log('remain stat point > 0');

      section.activateAllPlusBtns(true);

      if (falsy(header.isCheckedElixirStatCheckBox())) {
        console.log('checkbox not checked');
        header.activateElixirStatField(false);

      } else {
        console.log('checkbox checked');

        if (falsy(isLevelCanConsumeElixirStat( parseInt(_.statData.level - _.model.LEVEL_INIT) ))) { // 2019.11
          console.log(`can not consume elixir at ${_.statData.level} level`);
          header.activateElixirStatField(false);
        } else {
          console.log(`can consume elixir at ${_.statData.level} level`);
          header.activateElixirStatField(true);
        }
      }

    } else {
      console.log('remain stat point <= 0');

      if (isNaN(remainStat)) {
        header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);

      } else {
        if (falsy(header.isCheckedElixirStatCheckBox())) {
          console.log('checkbox not checked');

          header.setLevelUpBtnUsable(true, _.model.DEVICE_TYPE);
          header.activateElixirStatField(false);

        } else {
          if (_.statData.elixirStat <= 0) {
            console.log('checkbox checked. elixir is 0.');

            header.setLevelUpBtnUsable(true, _.model.DEVICE_TYPE);
            header.activateElixirStatField(false);

          } else {
            console.log('checkbox checked. elixir > 0.');

            if (falsy(isLevelCanConsumeElixirStat( parseInt(_.statData.level - _.model.LEVEL_INIT)))) { // 2019.11
              console.log(`can not consume elixir at ${_.statData.level} level`);
              header.setLevelUpBtnUsable(true, _.model.DEVICE_TYPE);
              header.activateElixirStatField(false);

            } else {
              console.log(`can consume elixir at ${_.statData.level} level`);

              header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);
              header.activateElixirStatField(true);

              section.activateAllPlusBtns(true);
            }

          }
        }
      }
    }

    if (elixirStat <= 0) _.header.activateElixirStatField(false);

    const str = parseInt10(_.statData.STR),
      dex = parseInt10(_.statData.DEX),
      int = parseInt10(_.statData.INT),
      con = parseInt10(_.statData.CON),
      wis = parseInt10(_.statData.WIS),
      cha = parseInt10(_.statData.CHA);

    if (parseInt10(statFirst.STR) < str) section.activateMinusBtn('STR', true);
    if (parseInt10(statFirst.DEX) < dex) section.activateMinusBtn('DEX', true);
    if (parseInt10(statFirst.INT) < int) section.activateMinusBtn('INT', true);
    if (parseInt10(statFirst.CON) < con) section.activateMinusBtn('CON', true);
    if (parseInt10(statFirst.WIS) < wis) section.activateMinusBtn('WIS', true);
    if (parseInt10(statFirst.CHA) < cha) section.activateMinusBtn('CHA', true);

    if (truthy(_.isCompleteSetBaseStat)) {
      if (falsy(header.isCheckedElixirStatCheckBox())) {
        console.log('checkbox not checked');

      } else {
        console.log('checkbox checked');

        if (_.statData.elixirStat <= 0) {
          console.log('checkbox checked. elixir is 0.');

        } else {
          console.log('checkbox checked. elixir > 0.');

          if (falsy(isLevelCanConsumeElixirStat( parseInt(_.statData.level - _.model.LEVEL_INIT)))) { // 2019.11
            console.log(`can not consume elixir at ${_.statData.level} level`);

          } else {
            console.log(`can consume elixir at ${_.statData.level} level`);
            section.activateAllPlusBtns(true);
          }
        }
      }

    } else {

      /* 초기 스탯 최대값 셋팅 업데이트 CSDT-547 20210512 */

      let STAT_MAX_AT_LEVEL_INIT_STR = _.model.STAT_MAX_AT_LEVEL_INIT,
          STAT_MAX_AT_LEVEL_INIT_DEX = _.model.STAT_MAX_AT_LEVEL_INIT,
          STAT_MAX_AT_LEVEL_INIT_INT = _.model.STAT_MAX_AT_LEVEL_INIT,
          STAT_MAX_AT_LEVEL_INIT_CON = _.model.STAT_MAX_AT_LEVEL_INIT,
          STAT_MAX_AT_LEVEL_INIT_WIS = _.model.STAT_MAX_AT_LEVEL_INIT,
          STAT_MAX_AT_LEVEL_INIT_CHA = _.model.STAT_MAX_AT_LEVEL_INIT;

      STAT_MAX_AT_LEVEL_INIT_DEX = ( parseInt10(_.option.classId) == 4 ) ? _.model.STAT_MAX_AT_LEVEL_INIT_DEX_4 : (parseInt10(_.option.classId) == 0) ? _.model.STAT_MAX_AT_LEVEL_INIT_DEX_0 : STAT_MAX_AT_LEVEL_INIT_DEX;
      STAT_MAX_AT_LEVEL_INIT_INT = ( parseInt10(_.option.classId) == 4 ) ? _.model.STAT_MAX_AT_LEVEL_INIT_INT_4 : (parseInt10(_.option.classId) == 0) ? _.model.STAT_MAX_AT_LEVEL_INIT_INT_0 : STAT_MAX_AT_LEVEL_INIT_INT;
      STAT_MAX_AT_LEVEL_INIT_WIS = ( parseInt10(_.option.classId) == 4 ) ? _.model.STAT_MAX_AT_LEVEL_INIT_WIS_4 : STAT_MAX_AT_LEVEL_INIT_WIS;

      if (STAT_MAX_AT_LEVEL_INIT_STR <= str) section.activatePlusBtn('STR', false);
      if (STAT_MAX_AT_LEVEL_INIT_DEX <= dex) section.activatePlusBtn('DEX', false);
      if (STAT_MAX_AT_LEVEL_INIT_INT <= int) section.activatePlusBtn('INT', false);
      if (STAT_MAX_AT_LEVEL_INIT_CON <= con) section.activatePlusBtn('CON', false);
      if (STAT_MAX_AT_LEVEL_INIT_WIS <= wis) section.activatePlusBtn('WIS', false);
      if (STAT_MAX_AT_LEVEL_INIT_CHA <= cha) section.activatePlusBtn('CHA', false);
    }

    // if level < 90, stat max value is 45.
    // if level >= 90, stat max value is 50.
    /* if (_.statData.level < _.model.LEVEL_CHANGE_STAT_MAX) {
      if (_.model.STAT_MAX <= str) section.activatePlusBtn('STR', false);
      if (_.model.STAT_MAX <= dex) section.activatePlusBtn('DEX', false);
      if (_.model.STAT_MAX <= int) section.activatePlusBtn('INT', false);
      if (_.model.STAT_MAX <= con) section.activatePlusBtn('CON', false);
      if (_.model.STAT_MAX <= wis) section.activatePlusBtn('WIS', false);
      if (_.model.STAT_MAX <= cha) section.activatePlusBtn('CHA', false);

    } else {
      if (_.model.CHANGED_STAT_MAX <= str) section.activatePlusBtn('STR', false);
      if (_.model.CHANGED_STAT_MAX <= dex) section.activatePlusBtn('DEX', false);
      if (_.model.CHANGED_STAT_MAX <= int) section.activatePlusBtn('INT', false);
      if (_.model.CHANGED_STAT_MAX <= con) section.activatePlusBtn('CON', false);
      if (_.model.CHANGED_STAT_MAX <= wis) section.activatePlusBtn('WIS', false);
      if (_.model.CHANGED_STAT_MAX <= cha) section.activatePlusBtn('CHA', false);
    }*/
    // 2021.12
    // 2022.01 .level-> .targetLevel
    const _getStatMax = getStatMaxByLevel(parseInt(_.statData.targetLevel), _.model.STAT_MAX_BY_LEVEL);

    if (_getStatMax <= str) section.activatePlusBtn('STR', false);
    if (_getStatMax <= dex) section.activatePlusBtn('DEX', false);
    if (_getStatMax <= int) section.activatePlusBtn('INT', false);
    if (_getStatMax <= con) section.activatePlusBtn('CON', false);
    if (_getStatMax <= wis) section.activatePlusBtn('WIS', false);
    if (_getStatMax <= cha) section.activatePlusBtn('CHA', false);

    if (_.statData.level >= _.statData.targetLevel) header.setLevelUpBtnUsable(false, _.model.DEVICE_TYPE);  // 2022.01 targetLevel


  }

  setLevelUpKeyEvents(deviceType) {
    const _ = this;

    if (deviceType === 'pc') {
      $(document)
        .off('keyup.levelup', '.simulator__stat')
        .on('keyup.levelup', '.simulator__stat', function (evt) {
          if (anyOf(evt.keyCode === 86, evt.which === 86)) $(_.header).trigger({type: Header.EVT_LEVEL_UP});
        });
    }
  }

  focusWrap(deviceType) {
    const _ = this;

    switch (deviceType) {
      case 'pc':
        $('.simulator__stat', _.wrap).focus();
        break;
    }
  }

  isEmptyRemainStat() {
    const _ = this;

    if (_.statData.remainStat > 0) {
      _.global.alert(ALERT.REQUIRE_EXHAUST_STAT); // '남은 스탯 포인트를 모두 배분해주세요.'

      return false;
    }

    return true;
  };

  destroyContents() {
    const _ = this;

    if (isDefined(_.topBar)) {
      _.setTopBarEvents(false);

      _.topBar.destroy();
      _.topBar = null;
    }

    if (isDefined(_.header)) {
      _.setHeaderEvents(false);

      _.header.destroy();
      _.header = null;
    }

    if (isDefined(_.section)) {
      _.setSectionEvents(false);

      _.section.destroy();
      _.section = null;
    }
  }

  destroy(obj = null) {
    const _ = this;

    _.destroyContents();

    _.wrap.empty();
  }

  /*
   * by setting qna board
   */
  removeTopBar() {
    const _ = this;

    if (isDefined(_.topBar)) {
      _.setTopBarEvents(false);

      _.topBar.destroy();
      _.topBar = null;
    }

    $('.simulator__stat > header', _.wrap).remove();
  }
}
StatSimulator.EVT_CLOSE = 'EVT_CLOSE';
StatSimulator.EVT_SAVE_STAT_COMPLETE = 'EVT_SAVE_STAT_COMPLETE';
StatSimulator.EVT_DELETE_STAT_COMPLETE = 'EVT_DELETE_STAT_COMPLETE';

export default StatSimulator;


// WEBPACK FOOTER //
// ./_src/js/world/characterSetting/stat/StatSimulator.js